import BidsFinesService from '@/api/BidsFinesService.js'
import Vue from 'vue'
export const bidsFinesModule = {
  namespaced: true,
  state: () => ({
    bidsFinesData: [],
    bidsFinesLoadStatus: 'request',
    paginationPromocodesStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPromocodesStateParams.total /
        state.paginationPromocodesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.bidsFinesData = [...data]
    },
    create(state, data) {
      state.bidsFinesData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.bidsFinesData.findIndex(
        (x) => x.request_service__id == data.id
      )
      Object.assign(state.bidsFinesData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.bidsFinesData.findIndex(
        (x) => x.request_service__id == id
      )
      state.bidsFinesData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPromocodesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.bidsFinesLoadStatus = 'request'
    },
    load_success(state) {
      state.bidsFinesLoadStatus = 'success'
    },
    load_error(state) {
      state.bidsFinesLoadStatus = 'error'
    }
  },
  actions: {
    getBidsFinesAll({ commit }, params) {
      commit('load_request')

      BidsFinesService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createBidsFinesData({ commit }, createData) {
      BidsFinesService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editBidsFinesMultiple({ commit }, { id, dataEdit }) {
      BidsFinesService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteBidsFinesData({ commit }, id) {
      // commit("load_request");
      BidsFinesService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
